// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://rsms.me/inter/inter.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body,
main,
#root {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: inter;
  color: black;
  background: #202025;
}

.content {
  width: 334px;
  height: 216px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow-y: auto;
  padding: 0;
}

.wrapper {
  padding: 10px;
  width: 668px;
  height: 432px;
  transform: scale(0.5);
  transform-origin: top left;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B","sourcesContent":["@import url('https://rsms.me/inter/inter.css');\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\nmain,\n#root {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: inter;\n  color: black;\n  background: #202025;\n}\n\n.content {\n  width: 334px;\n  height: 216px;\n  background: #f0f0f0;\n  border-radius: 3px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.wrapper {\n  padding: 10px;\n  width: 668px;\n  height: 432px;\n  transform: scale(0.5);\n  transform-origin: top left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
